export const customerReportVehicleOutcomeMutation = `
  mutation CustomerReportVehicleOutcome($input: CustomerReportVehicleOutcomeInput!) {
    customerReportVehicleOutcome(input: $input) {
      acquisitionName
    }
  }
`;
